import { ifyouApi, kevinAuthAPI, STORY } from 'apis/config';

export const liveBackgroundApi = {
  read: (projectId) =>
    ifyouApi.get(`${STORY}/${projectId}/live-bg-list`).then((res) => res.data),
  detail: (projectId, bgId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-bg-detail`, {
        live_bg_id: bgId,
      })
      .then((res) => res.data),
  register: (projectId, name) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-bg-register`, {
        live_bg_name: name,
      })
      .then((res) => res.data),
  update: (projectId, inputData) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-bg-update`, {
        live_bg_id: inputData.live_bg_id,
        live_bg_name: inputData.live_bg_name,
        offset_x: inputData.offset_x,
        offset_y: inputData.offset_y,
        game_scale: inputData.game_scale,
      })
      .then((res) => res.data),
  zipUpload: (projectId, formData) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-bg-upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
  delete: (projectId, bgId) =>
    ifyouApi
      .post(`${STORY}/${projectId}/live-bg-delete`, {
        live_bg_id: bgId,
      })
      .then((res) => res.data),
  // NEW API
  liveBackgroundList: (projectId) =>
    kevinAuthAPI
      .get(`/resource-manager/live/${projectId}/live_bg`)
      .then((res) => res.data),
  liveBackgroundCreate: (projectId, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_bg`, data)
      .then((res) => res.data),
  liveBackgroundZip: (projectId, id, data) =>
    kevinAuthAPI
      .post(`/resource-manager/live/${projectId}/live_bg/${id}`, data)
      .then((res) => res.data),
  liveBackgroundDelete: (projectId, id) =>
    kevinAuthAPI
      .delete(`/resource-manager/live/${projectId}/live_bg/${id}`)
      .then((res) => res.data),
  liveBackgroundUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/resource-manager/live/${projectId}/live_bg/${id}`, data)
      .then((res) => res.data),
  liveBackgroundThumnailUpdate: (projectId, id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return kevinAuthAPI
      .post(`/resource-manager/live-thumbnail/${projectId}/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data);
  },
};
